import { render, staticRenderFns } from "./nueva_pernocta.vue?vue&type=template&id=66ae2238&"
import script from "./nueva_pernocta.vue?vue&type=script&lang=js&"
export * from "./nueva_pernocta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports